import { render, staticRenderFns } from "./ListCalendarFeatured.vue?vue&type=template&id=42a60651&scoped=true&"
import script from "./ListCalendarFeatured.vue?vue&type=script&lang=js&"
export * from "./ListCalendarFeatured.vue?vue&type=script&lang=js&"
import style0 from "./ListCalendarFeatured.vue?vue&type=style&index=0&id=42a60651&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a60651",
  null
  
)

export default component.exports